import { Divider, Stack } from '@mui/material'
import React from 'react'

const DashboardDivider = () => (
  <Stack height={118} width={83} alignItems="center" justifyContent="center">
    <Divider
      orientation="vertical"
      sx={{
        width: 3,
        backgroundColor: 'primary.main',
      }}
    />
  </Stack>
)

export default DashboardDivider
